import React, { useState, useEffect } from 'react';
import AuthModal from '../components/auth/AuthModal';
import TrophyNotification from '../components/trophies/TrophyNotification';

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  useEffect(() => {
    const openAuth = () => setIsAuthModalOpen(true);
    window.addEventListener('open-auth', openAuth);
    return () => window.removeEventListener('open-auth', openAuth);
  }, []);

  return (
    <>
      {children}
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
      <TrophyNotification />
    </>
  );
};